/**
 * Shared crest component — renders the official tenant crest image when
 * available (with the initials as an accessibility-only fallback for
 * screen readers), otherwise falls back to the initials-in-gradient tile.
 *
 * Highlands directive: every visible crest across Education360 must use
 * the official uploaded artwork with no distortion / recolouring.
 */
import React from "react";

export default function TenantCrest({ tenant, size = "md", className = "", testId }) {
  const crest = tenant?.branding?.crest_url || tenant?.branding?.logo_url;
  const initials = (tenant?.short_name || tenant?.name || "H").slice(0, 2).toUpperCase();
  const sz = { sm: "w-8 h-8 text-xs", md: "w-11 h-11 text-sm", lg: "w-16 h-16 text-lg", xl: "w-24 h-24 text-2xl" }[size] || "";
  const props = crest
    ? { "data-crest-image": "1", style: { "--hl-crest-image": `url('${crest}')` } }
    : {};
  return (
    <span
      className={`hl-crest ${sz} ${className}`}
      role="img"
      aria-label={tenant?.name ? `${tenant.name} crest` : "School crest"}
      data-testid={testId || "tenant-crest"}
      {...props}
    >
      {initials}
    </span>
  );
}
